import { AlertCircle } from 'lucide-react';
import { Button } from '../primitives/Button';
import { cn } from '@shared/lib/cn';

/**
 * Editorial error state. Same silhouette as `EmptyState` but with a
 * danger-tinted icon and a retry CTA. Used as the fallback rendered when
 * a TanStack Query enters error state.
 */
interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

export function ErrorState({
  title = "Couldn't load this.",
  description = 'Try again, or check your connection.',
  onRetry,
  retryLabel = 'Try again',
  className,
}: ErrorStateProps): JSX.Element {
  return (
    <div className={cn('flex flex-col items-center justify-center text-center px-6 py-12', className)}>
      <div className="mb-4 text-danger">
        <AlertCircle className="h-7 w-7" strokeWidth={1.5} />
      </div>
      <h2 className="font-display text-display-lg text-ink">{title}</h2>
      <p className="text-body text-ink-secondary mt-2 max-w-sm">{description}</p>
      {onRetry ? (
        <div className="mt-6">
          <Button variant="secondary" onClick={onRetry}>
            {retryLabel}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
